<template>
  <div>
    <PermissionsErrorLayout>
      <div slot="permissions-error-item">
        <PermissionsErrorItem />
      </div>
    </PermissionsErrorLayout>
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import PermissionsErrorLayout from './components/PermissionsErrorLayout/PermissionsErrorLayout.vue';
import PermissionsErrorItem from './components/PermissionsErrorItem/PermissionsErrorItem.vue';
import './styles/permissions-error.scss';

@Component({
  components: {
    PermissionsErrorLayout,
    PermissionsErrorItem
  }
})
export default class PermissionsError extends Vue {}
</script>
